export interface Feature {
  id: string;
  name: string;
  route: string;
  icon: string;
  description: string;
  requiredGroups?: string[];
}

// AUTH-003 (Round 5 sweep #37, finding dd9e7606): the previous code
// embedded a hardcoded fallback GUID (d63b7a80-...) for the profile
// admin group whenever REACT_APP_PROFILE_ADMIN_GROUP_ID was unset.
// That GUID was specific to one Entra tenant — it would silently
// either grant or deny access incorrectly in any other tenant.
// Reading it once at module load and passing it down (empty when
// unset) lets the gating logic fail closed instead.
const profileAdminGroupId =
  (typeof process !== 'undefined' && process.env.REACT_APP_PROFILE_ADMIN_GROUP_ID) || '';
const adminOnlyGroups: string[] = profileAdminGroupId ? [profileAdminGroupId] : [];

export const features: Feature[] = [
  {
    id: 'enhancer',
    name: 'Profile',
    route: '/enhancer',
    icon: 'auto_awesome',
    description: 'AI-powered profile enhancement to improve and polish your own professional profile'
  },
  {
    id: 'proposal-generator',
    name: 'Proposals',
    route: '/proposal-generator',
    icon: 'group',
    description: 'Create tailored professional bios for proposal presentations by combining consultant profiles with client context'
  },
  {
    id: 'cv-redactor',
    name: 'Providers',
    route: '/cv-redactor',
    icon: 'badge',
    description: 'AI-powered CV redaction to protect sensitive information while maintaining document integrity'
  },
  {
    id: 'batch-profiles',
    name: 'Batch Profiles',
    route: '/batch-profiles',
    icon: 'folder_special',
    description: 'Administrative tool to create professional profiles in bulk from SharePoint materials',
    requiredGroups: adminOnlyGroups
  },
  {
    id: 'profile-pictures',
    name: 'Profile Pictures',
    route: '/profile-pictures',
    icon: 'photo_camera',
    description: 'Manage professional headshots and sync primary photos to Microsoft Graph',
    requiredGroups: adminOnlyGroups
  },
  {
    // MS-002 (Round 4 #87): manifest declares /contractor-profile as a
    // self-service path for independent contractors, so the feature
    // registry no longer gates it on profile-admin group membership.
    // The route is authenticated (any signed-in user with an allowed
    // email domain reaches it); per-user gating lives in the backend
    // /api/contractor-profile/consent flow.
    id: 'contractor-profile',
    name: 'Contractor Profile',
    route: '/contractor-profile',
    icon: 'person',
    description: 'Self-service professional profile creation for independent consultants'
  },
  {
    id: 'project-tracker',
    name: 'Projects',
    route: '/projects',
    icon: 'work',
    description: 'Track team contributions across projects with roles, activities, and hours'
  }
  // Future features can be added here
  // {
  //   id: 'document-analyzer',
  //   name: 'Document Analyzer',
  //   route: '/document-analyzer',
  //   icon: 'analytics',
  //   description: 'Analyze documents for compliance and data insights'
  // }
];
